var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C18.9782 0 22.7936 1.58035 25.6066 4.3934C28.4196 7.20644 30 11.0218 30 15C30 18.9782 28.4196 22.7936 25.6066 25.6066C22.7936 28.4196 18.9782 30 15 30C11.0218 30 7.20644 28.4196 4.3934 25.6066C1.58035 22.7936 0 18.9782 0 15C0 11.0218 1.58035 7.20644 4.3934 4.3934C7.20644 1.58035 11.0218 0 15 0ZM37.5 2.5C41.25 2.5 43.75 8.0975 43.75 15C43.75 21.9025 41.25 27.5 37.5 27.5C33.75 27.5 31.25 21.9025 31.25 15C31.25 8.0975 33.75 2.5 37.5 2.5ZM47.5 3.75C48.45 3.75 49.28 5.8175 49.7 9.365L49.8175 10.4725L49.865 11.06L49.94 12.295L49.965 12.9425L49.995 14.295L50 15L49.995 15.705L49.965 17.0575L49.94 17.7075L49.865 18.94L49.815 19.5275L49.7025 20.635C49.28 24.185 48.4525 26.25 47.5 26.25C46.55 26.25 45.72 24.1825 45.3 20.635L45.1825 19.5275C45.1653 19.3318 45.1495 19.1359 45.135 18.94L45.06 17.705C45.0503 17.4892 45.042 17.2734 45.035 17.0575L45.005 15.705V14.295L45.035 12.9425L45.06 12.2925L45.135 11.06L45.185 10.4725L45.2975 9.365C45.72 5.815 46.5475 3.75 47.5 3.75Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedium);
export default __webpack_public_path__ + "static/media/icon-medium.27e3f47bb43771b2c4561dd952203cc3.svg";
export { ForwardRef as ReactComponent };